module.exports = __webpack_public_path__ + "img/29.8.TSS.523a0436.png";